import { createNode, PlainDateDataType } from '@glueapp/graph-types';
import { Temporal } from '@js-temporal/polyfill';
import { fromPlainDate } from '../../utils/temporal';

export const ParseDate = createNode({
    id: 'Parse Date',
    name: 'Parse Date',
    description: 'Parses a Date from an ISO 8601 string (e.g. "2024-03-15")',
    aiDescription: 'Takes an ISO 8601 date string (e.g. "2024-03-15") on the "Text" port and outputs a parsed Date on the "Date" port.',
    category: 'Date & Time',
    color: '#3b82f6',
    integration: undefined,
    inPorts: {
        Text: { kind: 'string' },
    },
    outPorts: {
        Date: PlainDateDataType,
    },
    execute: function (input) {
        const date = Temporal.PlainDate.from(input.inPorts.Text);
        return { output: { Date: fromPlainDate(date) } };
    },
});
